import { useContext, useEffect, useState } from "react"
import { MemberProfileComponent } from "../../../components/DeveloperComponents"
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io"
import { useTranslation } from "react-i18next"
import { calculateTimePassed } from "../../../components/TimeComponents"
import { formatTimestamp } from "../../../utils"
import { MemberSearchComponent } from "../../../components/MemberSearchComponents"
import { Pagination } from "../../../components/PaginationComponents"
import { AccountContext } from "../../../contexts/AccountContexts"
import { rowsPerPage } from "../../../entries"
import { PageHeader } from "../../../components/HeaderComponents"


export const SearchBannedPage = () => {
    const { t } = useTranslation('common')
    const { user } = useContext(AccountContext)
    const [members, setMembers] = useState([])

    const [currentPage, setCurrentPage] = useState(1)
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });
    const [entriesPerPage, setEntriesPerPage] = useState(localStorage.getItem(user.id + "_perPageMembersBanned") ? parseInt(localStorage.getItem(user.id + "_perPageMembersBanned")) : 10);
    const [totalPages, setTotalPages] = useState(0)
    const [totalCount, setTotalCount] = useState(0)


    const handleSearchMembers = (mems) => {
        setMembers((prev) => [...mems])
    }


    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        if (sortConfig.key === key && sortConfig.direction === "desc") {
            key = null
        }
        if (sortConfig.key !== key || sortConfig.direction !== direction) {
            setCurrentPage(1)
        }

        setSortConfig({ key, direction });
    };

    const getArrow = (key) => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === "asc") {
                return <IoMdArrowDropup size={16} className="inline ml-1" />;
            } else {
                return <IoMdArrowDropdown size={16} className="inline ml-1" />;
            }
        }
        return null;
    };

    const handlePerPage = (event) => {
        localStorage.setItem(user.id + "_perPageMembersBanned", event.target.value)
        if (event.target.value !== entriesPerPage) {
            setCurrentPage(1)
        }
        setEntriesPerPage(event.target.value)
    }

    const formatBanned = (bannedUntil) => {
        if (bannedUntil === 0) {
            return "-"
        }
        else if (bannedUntil === -1) {
            return t("Indefinite", { ns: "settings" })
        }
        else {
            return formatTimestamp(bannedUntil * 1000)
        }
    }

    return (
        <div className="flex flex-col justify-start items-center w-full py-2 gap-5 pb-10 px-4 h-full">
            <PageHeader pageTitle={t("Banned (Support)", {ns: "settings"})} />
            <MemberSearchComponent banned={true} getData={handleSearchMembers} currentPage={currentPage} setCurrentPage={setCurrentPage} entriesPerPage={entriesPerPage} setEntriesPerPage={setEntriesPerPage} sortConfig={sortConfig} setSortConfig={setSortConfig} setTotalCount={setTotalCount} setTotalPages={setTotalPages} />
            <main className="flex flex-col items-center w-full mx-auto  bg-white dark:bg-gray-700 rounded-xl shadow-sm  gap-4 h-full">
                <div className="flex w-full mt-4 px-4 gap-2 items-center justify-between">
                    <div className="flex gap-4 items-center">
                        <div className="flex gap-2 items-center">

                            <select required className=" select select-sm h-10 select-bordered w-[70px] bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-300 dark:border-gray-600" value={entriesPerPage} onChange={handlePerPage}>
                                {rowsPerPage.map((i, index) => (<option key={index} value={i} >{i}</option>))}
                            </select>
                            <p>{t('entries per page')}</p>
                        </div>
                    </div>
                    <div className="">
                        <p>{totalCount ? totalCount : members.length} {t('entries')}</p>
                    </div>
                </div>
                <table className="table  w-full" >
                    <thead className="bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-300">
                        <tr className="border-gray-300 dark:border-gray-600">
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { handleSort("name") }}>
                                <div className="flex items-center">
                                    {t("NAME")} {getArrow("name")}
                                </div>
                            </th>
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { handleSort("email") }}>
                                <div className="flex items-center">
                                    {t("EMAIL")} {getArrow("email")}
                                </div>
                            </th>
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { handleSort("banned_until") }}>
                                <div className="flex items-center">
                                    {t("BANNED")} {getArrow("banned_until")}
                                </div>
                            </th>
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { }}>
                                <div className="flex items-center">
                                    {t("LONGEST ACTIVE")}
                                </div>
                            </th>
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { }}>
                                <div className="flex items-center">
                                    {t("ACTIVE TICKETS")}
                                </div>
                            </th>
                            <th className="max-w-xs truncate cursor-pointer select-none" onClick={() => { }}>
                                <div className="flex items-center">
                                    {t("TOTAL TICKETS")}
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            members
                                .map((member, index) =>
                                    <tr key={index} className="h-12 border-gray-300 dark:border-gray-600">
                                        <td className={`max-w-xs truncate`}><MemberProfileComponent ticket={member} member={member} /></td>
                                        <td className={`max-w-xs truncate ${member?.banned && "text-red-600"}`}>{member.email}</td>
                                        <td className="max-w-xs truncate">{formatBanned(member.banned_until)}</td>
                                        <td className="max-w-xs truncate">{member.longest_active_createdAt > 0 ? calculateTimePassed(member.longest_active_createdAt * 1000, t).text : "-"} </td>
                                        <td className="max-w-xs truncate">{member.n_active_tickets} </td>
                                        <td className="max-w-xs truncate">{member.n_tickets} </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
                {members.length === 0 && <span className="italic">{t("No entries found")}</span>}
                <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
            </main>
        </div>
    )
}